import React, { Component } from "react"
import Svg from "../_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export class ItineraryObsBlock extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      accordionOpen: false,
    }

    this.showHideContent = this.props.showHideContent.bind(this)
  }

  handleAccordionClick = (e) => {
    this.showHideContent(e, ".contentWrapper")
    this.setState({ accordionOpen: !this.state.accordionOpen })
  }

  render() {
    const obsIcon = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.obsIcon)
    const backgroundColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.backgroundColor)
    return (
      <div className={`departure-info__essentials__detailitems__detailitem__infobox__obs foldable ${backgroundColor ? backgroundColor : ""}`}>
        <button
          className="departure-info__essentials__detailitems__detailitem__infobox__obs__header pointer"
          aria-expanded={this.state.accordionOpen}
          aria-label={
            this.state.accordionOpen
              ? `${this.props.currentPageJson?.closeContentLabel || "Luk indhold for sektionen"} ${this.props.block.obsHeadline}`
              : `${this.props.currentPageJson?.openContentLabel || "Åben indhold for sektionen"} ${this.props.block.obsHeadline}`
          }
          onClick={(e) => this.handleAccordionClick(e)}
        >
          {this.props.block.obsIconUpload ? <img className="icon" src={this.props.block.obsIconUpload} /> : obsIcon ? <Svg iconName={obsIcon} /> : ""}
          {this.props.block.obsHeadline}
        </button>
        <div className={"contentWrapper show-hide hide-content"}>
          <div className="info-text rich-text" dangerouslySetInnerHTML={{ __html: this.props.block.obsText }}></div>
        </div>
      </div>
    )
  }
}
